export default __webpack_public_path__ + "static/media/shopping-list.c522ac19.svg";